import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-tax-identification-number',
  imports: [ReactiveFormsModule],
  templateUrl: './tax-identification-number.html',
  styleUrl: './tax-identification-number.scss',
})
export class TaxIdentificationNumber {
  pharmacyForm = input.required<FormGroup>();
}
